export default __webpack_public_path__ + "static/media/sandcrab2.825af355.jpeg";